module.exports = __webpack_public_path__ + "img/sectors-img01.e42bbb74.jpg";